<!--
 * @Author: xiehangyi
 * @LastEditors: xiehangyi
 * @Description: 图片列表
-->
<template>
  <div class="lc-image-list" ref="lcImageList">
    <div
      v-if="imageList.length"
      class="lc-image-list__names"
      :style="namesStyle"
    >
      <div
        v-for="(item, index) in imageList"
        :key="index"
        class="lc-image-list__names-item"
      >
        {{ item[nameKey] }}
      </div>
    </div>
    <div class="lc-image-list__images">
      <div
        v-for="(column, colIndex) in reColumns"
        :key="column"
        class="lc-image-list__images-column"
        :style="imagesStyle"
      >
        <div
          v-for="(item, index) in getImageList(colIndex)"
          :key="index"
          :ref="'imageList' + colIndex"
          class="lc-image-list__images-item"
          :style="imagesItemStyle"
        >
          <el-image class="lc-image-list__images-item-img" :src="item">
            <div slot="error" class="image-slot">
              <el-image class="lc-image-list__images-item-img" :src="defaultImage" />
            </div>
          </el-image>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { request } from '@/apis/request'
import defaultImage from '@/assets/images/default-image.png';
export default {
  name: 'LcImageList',
  props: {
    columns: {
      type: [Number, String],
      default: 2
    },
    imageWidth: {
      type: String,
      default: '200px'
    },
    imageInterval: {
      type: String,
      default: '5px'
    },
    imageKey: {
      type: String,
      default: 'image'
    },
    nameKey: {
      type: String,
      default: 'name'
    },
    // 导出的url
    action: {
      type: String,
      default: ''
    },
    // 导出url请求类型
    method: {
      type: String,
      default: 'GET'
    },
    // 导出的请求头部
    headers: {
      type: Object,
      default: () => ({})
    },
    // 导出附带的额外参数
    data: {
      type: Object,
      default: () => ({})
    },
    // 设置导出请求的返回数据类型
    responseType: {
      type: String,
      default: 'APPLICATION/JSON'
    },
    responseDataName: {
      type: String,
      default: 'data'
    }
  },
  data() {
    return {
      defaultImage,
      defaultImageInfo: {},
      imageList: [],
      waterfallData: {
        imageList0: [],
        imageListHeight0: 0
      },
      canvas: document.createElement('canvas'),
      nextLoadImgNumber: 10, // 后续每次加载图片数量
      currentLoadedImgNumber: 0, // 当前已加载图片数量
      isLoadImage: false,
    }
  },
  computed: {
    reColumns() {
      return this.columns ? parseInt(this.columns) : 2
    },
    namesStyle() {
      return `
        margin-top: ${this.imageInterval};
      `
    },
    imagesStyle() {
      const imgWidthNumber = parseInt(this.imageWidth)
      const defaultStyle = `margin-left: ${this.imageInterval};`
      if (!imgWidthNumber) {
        return `
          ${defaultStyle}
          width: calc(100% / ${this.reColumns});
        `
      }
      return defaultStyle
    },
    imagesItemStyle() {
      const imgWidthNumber = parseInt(this.imageWidth)
      const imageWidth = imgWidthNumber ? this.imageWidth : `100%`
      return `
        width: ${imageWidth};
        margin-top: ${this.imageInterval};
      `
    }
  },
  created() {
    this.initData()
    this.getDefaultImageInfo()
  },
  mounted() {
    this.queryImageList()
    this.bindEvent()
  },
  methods: {
    initData() {
      for (let i = 0; i < this.reColumns; i++) {
        this.$set(this.waterfallData, `imageList${i}`, [])
        this.$set(this.waterfallData, `imageListHeight${i}`, 0)
      }
    },
    bindEvent() {
      const lcImageList = this.$refs.lcImageList
      lcImageList.onscroll = () => {
        const scrollHeight = lcImageList.scrollHeight
        const clientHeight = lcImageList.clientHeight
        const scrollTop = lcImageList.scrollTop
        if (clientHeight + scrollTop > scrollHeight - 10) {
          this.buildImageListNext()
        }
      }
    },
    getDefaultImageInfo() {
      const img = new Image()
      img.src = this.defaultImage
      img.onload = () => {
        this.defaultImageInfo = img
      }
    },
    queryImageList() {
      if(!this.action) {
        this.$message.info('图片列表暂无可用请求地址！')
        return
      }
      request({
        url: this.action,
        method: this.method,
        headers: this.headers,
        params: this.data,
        data: this.data,
        responseType: this.responseType
      }).then(res => {
        const newImageList = res[this.responseDataName]
        this.imageList.push(...newImageList);
        this.buildImageListFirst();
      }).catch(res => {
        const newImageList = [
          {
            name: '图片1',
            image: 'https://t7.baidu.com/it/u=2604797219,1573897854&fm=193&f=GIF'
          }, {
            name: '图片2',
            image: 'https://img0.baidu.com/it/u=2224195194,2552213713&fm=253&fmt=auto&app=138&f=JPEG?w=800&h=500'
          }, {
            name: '图片3',
            image: 'https://img0.baidu.com/it/u=61183202,3425279497&fm=253&fmt=auto&app=138&f=JPEG?w=667&h=500'
          }, {
            name: '图片4',
            image: 'https://img0.baidu.com/it/u=1986763614,4057162670&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=666'
          }, {
            name: '图片5',
            image: 'https://img2.baidu.com/it/u=3995794575,3231832611&fm=253&fmt=auto&app=138&f=JPEG?w=755&h=500'
          }, {
            name: '图片6',
            image: 'https://img0.baidu.com/it/u=1885009107,1276967789&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=890'
          }, {
            name: '图片7',
            image: 'https://img0.baidu.com/it/u=1270878204,157608605&fm=253&fmt=auto&app=120&f=JPEG?w=1200&h=675'
          }, {
            name: '图片8',
            image: 'https://img2.baidu.com/it/u=481755904,3535490584&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=375'
          }, {
            name: '图片9',
            image: 'https://img0.baidu.com/it/u=2671546634,3324342902&fm=253&fmt=auto&app=138&f=JPEG?w=889&h=500'
          }, {
            name: '图片10',
            image: 'https://img2.baidu.com/it/u=763891380,2155426535&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=313'
          }
        ]
        this.imageList.push(...newImageList);
        this.buildImageListFirst();
      })
    },
    getImageList(index) {
      return this.waterfallData[`imageList${index}`]
    },
    async buildImageListFirst() {
      this.isLoadImage = true
      await this.buildImageWaterfall(0, () => {
        const height = this.$refs.lcImageList.clientHeight
        let isBreak = true
        for (let index = 0; index < this.reColumns; index++) {
          if (this.waterfallData[`imageListHeight${index}`] <= height) {
            isBreak = false
            break
          }
        }
        return isBreak
      })
      this.isLoadImage = false
    },
    async buildImageListNext() {
      if (this.isLoadImage || this.currentLoadedImgNumber >= this.imageList.length) {
        return
      }
      this.isLoadImage = true
      const startIndex = this.currentLoadedImgNumber
      const loadNumber = this.nextLoadImgNumber * this.reColumns
      await this.buildImageWaterfall(startIndex, () => {
        if (this.currentLoadedImgNumber - startIndex >= loadNumber) return true
        return false
      })
      this.isLoadImage = false
    },
    /**
     * 创建图片瀑布流
     * @param startIndex 从imageList某条数据开始循环
     * @param breakFn 退出条件
     */
    async buildImageWaterfall(startIndex, breakFn) {
      while (startIndex < this.imageList.length) {
        const image = this.imageList[startIndex][this.imageKey]
        const index = this.findImageListMinHeightIndex()
        const imgData = await this.imageRender(index, image)
        this.waterfallData[`imageListHeight${index}`] += (imgData.height + parseInt(this.imageInterval))
        this.waterfallData[`imageList${index}`].push(imgData.src)
        startIndex++
        this.currentLoadedImgNumber++
        if (breakFn()) return
      }
    },
    findImageListMinHeightIndex() {
      let minIndex = 0
      for (let i = 1; i < this.reColumns; i++) {
        if (this.waterfallData[`imageListHeight${i}`] < this.waterfallData[`imageListHeight${minIndex}`]) {
          minIndex = i
        }
      }
      return minIndex
    },
    imageRender(index, image) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.src = image
        img.crossOrigin = 'Annoymous'
        img.onload = () => {
          let imgWidth = parseInt(this.imageWidth)
          if (!imgWidth) {
            imgWidth = this.$refs[`imageList${index}`][0].offsetWidth
          }
          resolve({
            src: this.getImageBase64(img),
            height: imgWidth * img.height / img.width
          })
        }
        img.onerror = () => {
          let imgWidth = parseInt(this.imageWidth)
          if (!imgWidth) {
            imgWidth = this.$refs[`imageList${index}`][0].offsetWidth
          }
          resolve({
            src: this.defaultImage,
            height: imgWidth * this.defaultImageInfo.height / this.defaultImageInfo.width
          })
        }
      })
    },
    getImageBase64(img) {
      const ctx = this.canvas.getContext('2d')
      this.canvas.width = img.width
      this.canvas.height = img.height
      ctx.drawImage(img, 0, 0)
      return this.canvas.toDataURL('image/jpg')
    }
  }
}
</script>
<style lang="scss">
.lc-image-list {
  display: flex;
  width: 100%;
  height: 100%;
  overflow: auto;
  &__names {
    width: 80px;
    border: 1px solid #ccc;
    padding: 10px;
    color: #222;
    &-item {
      width: 80px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  &__images {
    display: flex;
    flex-wrap: nowrap;
    flex: 1;
    &-item {
      flex-shrink: 0;
      &-img {
        display: block;
        width: 100%;
        height: 100%;
        color: #999;
      }
    }
  }
}
</style>